<template>
  <main-layout :showFooter="false">
    <router-view/>
  </main-layout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout.vue'

export default {
  components: {
    MainLayout
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/AddressBook.vue